import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "modal__title" };
import { onMounted, ref } from 'vue';
import Modal from "@astina/paloma-common-ui/src/components/Modal.vue";
import AppForm from "@astina/paloma-common-ui/src/components/form/AppForm.vue";
import customerRepository from "../services/CustomerRepository";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartDeliveryLocationForm',
    props: {
        createFunction: { type: Function }
    },
    emits: [
        'success',
        'close'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const form = ref(null);
        const deliveryLocation = ref({
            title: "",
            address: {}
        });
        const validation = ref({ errors: [], fields: {} });
        onMounted(() => {
            customerRepository
                .getDeliveryLocationForm()
                .then(f => {
                form.value = f;
            });
        });
        function save() {
            props.createFunction(deliveryLocation.value)
                .then(() => {
                emit('success');
                close();
            })
                .catch((v) => {
                validation.value = v;
            });
        }
        function cancel() {
            close();
        }
        function close() {
            emit('close');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Modal, { onClose: cancel }, {
                header: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cart.add_delivery_location')), 1)
                ]),
                content: _withCtx(() => [
                    (form.value)
                        ? (_openBlock(), _createBlock(AppForm, {
                            key: 0,
                            form: form.value,
                            data: deliveryLocation.value,
                            validation: validation.value,
                            onSubmit: save,
                            onCancel: cancel
                        }, null, 8, ["form", "data", "validation"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
